import tabData from "../data/industryData";
import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import SlidOnScrollBanner from "../components/slide-on-scroll-banner/SlidOnScrollBanner";
import Footer from "../components/footer/Footer";
import HomeLogo from "../components/home-logos/HomeLogo";
import WhyUs from "../components/whyus/WhyUs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import EngagmentModels from "../components/engagmentModels/EngagmentModels";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import TypeIndustries from "../components/typeIndustry/TypeIndustries";
import ContactSection from "../components/contactSection/ContactSection";
import BrandImages from "../components/brandImages/BrandImages";
import HireForUs from "../components/hire-us-for/HireForUs";
import MainEnterpriseItServices from "../components/enterprise-it-services/MainEnterpriseItServices";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import PageScroller from "../components/page-scroller/PageScroller";
import OurLocations from "../components/ourlocations/OurLocations";
import Testimonial from "../components/testimonila/Testimonial";
import BootstrapModal from "../components/modals/submit-email-modal";
import MyModal from "../components/modals/submit-email-modal";
import NewEngagementModels from "../components/new-engagment-modal";
import { UsaSectionsData } from "../data/UsaBannerData";
import { AusScrollerData, AustraliaSectionsData } from "../data/AustraliaData";
import FloatingButtons from "../components/floating-buttons";
import ClutchIcon from "../components/clutch-icon";
import OurTeams from "../components/our-teams/OurTeams";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import IndustriesSection from "../components/newIndustriesSection";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import OurServices from "../components/our-services/OurServices";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import MegaMenu from "../components/MegaMenu/MegaMenu";

function AustraliaHome() {
  // const { t } = useTranslation("industries");
  // const translatedTabData = t("tabData", { returnObjects: true });

  const { t } = useTranslation("engagementModelContent");

  // grab the full object once
  const engagementModelsContent = {
    heading: t("heading"),
    darkHeading: t("darkHeading"),
    subheading: t("subheading"),
    models: t("models", { returnObjects: true }),
    cta: t("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  const { t: servicesSection } = useTranslation("ksaHome");
  const ksaHomehireServicesInsights = servicesSection("servicesInsights", {
    returnObjects: true,
  });

  const tabs = [
    "AI",
    "Blockchain",
    // "Cyber Security",
    "Database",
    "Backend",
    "Frontend",
    "Mobile",
    "Frameworks",
    "Cloud",
    "DevOps",
    "Ecommerce",
    "Platforms",
  ];

  const tabItems = [
    {
      tab: "AI",
      icon: "/images/genai1.svg",
      name: "CycleGAN",
    },
    {
      tab: "AI",
      icon: "/images/genai2.svg",
      name: "DeepArt",
    },
    {
      tab: "AI",
      icon: "/images/genai3.svg",
      name: "DeepDream",
    },
    { tab: "AI", icon: "/images/genai4.svg", name: "VQ-VAE" },
    { tab: "AI", icon: "/images/genai5.svg", name: "GPT-4" },
    { tab: "AI", icon: "/images/genai6.svg", name: "GPT-3" },
    { tab: "AI", icon: "/images/genai6.svg", name: "DALL-E" },
    { tab: "AI", icon: "/images/genai6.svg", name: "OpenAI GPT" },
    {
      tab: "AI",
      icon: "/images/genai6.svg",
      name: "OpenAI DALL-E",
    },
    {
      tab: "AI",
      icon: "/images/module1.svg",
      name: "DeepMind Sonnet",
    },
    {
      tab: "AI",
      icon: "/images/module2.svg",
      name: "Facebook AI Research ",
    },
    {
      tab: "AI",
      icon: "/images/module3.svg",
      name: "Hugging Face",
    },
    {
      tab: "AI",
      icon: "/images/module4.svg",
      name: "NVIDIA StyleGAN",
    },
    {
      tab: "AI",
      icon: "/images/tech-icon.svg",
      name: "PyTorch",
    },
    {
      tab: "AI",
      icon: "/images/tech-icon2.svg",
      name: "Keras",
    },
    {
      tab: "AI",
      icon: "/images/tech-icon3.svg",
      name: "MXNet",
    },
    {
      tab: "AI",
      icon: "/images/tech-icon4.svg",
      name: "TensorFlow",
    },
    {
      tab: "AI",
      icon: "/images/tech-icon5.svg",
      name: "Caffe",
    },
    { tab: "AI", icon: "/images/natural1.svg", name: "RBM" },
    { tab: "AI", icon: "/images/natural2.svg", name: "DBN" },
    {
      tab: "AI",
      icon: "/images/natural7.svg",
      name: "Transformers",
    },
    {
      tab: "AI",
      icon: "/images/natural4.svg",
      name: "Autoencoders",
    },
    { tab: "AI", icon: "/images/natural5.svg", name: "DRLN" },
    { tab: "AI", icon: "/images/natural6.svg", name: "GAN" },
    { tab: "AI", icon: "/images/tech-icon.svg", name: "PyTorch" },
    { tab: "AI", icon: "/images/tech-icon2.svg", name: "Keras" },
    { tab: "AI", icon: "/images/tech-icon3.svg", name: "MXNet" },
    { tab: "AI", icon: "/images/libraries1.svg", name: "FastAI" },
    { tab: "AI", icon: "/images/libraries2.svg", name: "TensorFlow" },
    { tab: "AI", icon: "/images/libraries3.svg", name: "Theano" },
    { tab: "AI", icon: "/images/libraries4.svg", name: "Scikit-learn" },
    {
      tab: "AI",
      icon: "/images/calsification.svg",
      name: "AlexNet",
    },
    {
      tab: "AI",
      icon: "/images/calsification2.svg",
      name: "EfficientNet",
    },
    {
      tab: "AI",
      icon: "/images/calsification3.svg",
      name: "Xception",
    },
    {
      tab: "AI",
      icon: "/images/calsification4.svg",
      name: "DenseNet",
    },
    {
      tab: "AI",
      icon: "/images/calsification5.svg",
      name: "Inception",
    },
    {
      tab: "AI",
      icon: "/images/calsification6.svg",
      name: "ResNet",
    },
    {
      tab: "AI",
      icon: "/images/calsification7.svg",
      name: "VGGNet",
    },
    // CYBER SECURITY ICONS
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/burp-suite.png",
      name: "Brup Suite",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/check-point.png",
      name: "Check Point",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/cisco-secures.png",
      name: "Ciso Secures",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/crowd-strike.png",
      name: "Crowd Strike",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/dark-trace.png",
      name: "Dark Trace",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/fortinet.png",
      name: "Fortinet",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/kali.png",
      name: "Kali",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/metasploit.png",
      name: "Metasploit",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/nessus.png",
      name: "Nessus",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/qradar-logo.png",
      name: "IBM Radar",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/qualys.png",
      name: "Qualys",
    },

    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/snort.png",
      name: "Snort",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/splunk.png",
      name: "Splunk",
    },
    {
      tab: "Cyber Security",
      icon: "/images/tech-stack-icons/wire-shark.png",
      name: "Wire Shark",
    },
    // Blockchain Platforms
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/ethereum.png",
      name: "Ethereum",
    },
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/stellar.png",
      name: "Stellar",
    },
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/Ripple.png",
      name: "Ripple",
    },

    // Enterprise Solutions
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/Hyperledger.png",
      name: "HyperLedger",
    },
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/microsoft-icon.png",
      name: "Azure Blockchain",
    },
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/download-3.png",
      name: "Azure Service Fabric",
    },

    // Consensus Mechanisms
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/tendermint-logo-black.png",
      name: "Tendermint",
    },

    // Storage Solutions
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/IPFS_logo.png",
      name: "IPFS",
    },
    {
      tab: "Blockchain",
      icon: "/images/tech-stack-icons/Bigchaindb.png",
      name: "BigChainDB",
    },
    { tab: "Frontend", icon: "/images/iconone.png", name: "Angular JS" },
    { tab: "Frontend", icon: "/images/icontwo.png", name: "JavaScript" },
    { tab: "Frontend", icon: "/images/iconthree.png", name: "React JS" },
    { tab: "Frontend", icon: "/images/icon4.png", name: "Vue JS" },
    { tab: "Frontend", icon: "/images/icon5.png", name: "Tez JS" },
    { tab: "Frontend", icon: "/images/icon6.png", name: "CSS3" },
    { tab: "Frontend", icon: "/images/icon7.png", name: "HTML5" },
    { tab: "Backend", icon: "/images/database1.png", name: ".Net" },
    { tab: "Backend", icon: "/images/database2.png", name: "Nest Js" },
    { tab: "Backend", icon: "/images/database3.png", name: "Meteor JS" },
    { tab: "Backend", icon: "/images/database4.png", name: "Fastify" },
    { tab: "Backend", icon: "/images/database5.png", name: "Express JS" },
    { tab: "Backend", icon: "/images/database6.png", name: "Python" },
    { tab: "Backend", icon: "/images/database7.png", name: "Java" },
    { tab: "Backend", icon: "/images/database8.png", name: "PHP" },
    { tab: "Backend", icon: "/images/database9.png", name: "Node Js" },
    { tab: "Mobile", icon: "/images/mobile1.png", name: "Android" },
    { tab: "Mobile", icon: "/images/mobile2.png", name: "IOS" },
    { tab: "Mobile", icon: "/images/mobile3.png", name: "Swift" },
    { tab: "Mobile", icon: "/images/mobile4.png", name: "Flutter" },
    { tab: "Mobile", icon: "/images/mobile5.png", name: "Xamarin" },
    { tab: "Mobile", icon: "/images/mobile6.png", name: "React Native" },
    { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
    { tab: "Database", icon: "/images/db2.png", name: "Oracle " },
    { tab: "Database", icon: "/images/db3.png", name: "MongoDB" },
    {
      tab: "Database",
      icon: "/images/tech-stack-icons/postgres.svg",
      name: "PostgreSQL",
    },
    { tab: "Database", icon: "/images/db5.png", name: "MySQL" },
    { tab: "Database", icon: "/images/db6.png", name: "SQL Server" },
    { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
    { tab: "Database", icon: "/images/db8.png", name: "DynamoDB" },
    { tab: "Frameworks", icon: "/images/framework6.png", name: "Django" },
    { tab: "Frameworks", icon: "/images/framework2.png", name: "CodeIgniter" },
    { tab: "Frameworks", icon: "/images/framework3.png", name: "Laravel" },
    { tab: "Frameworks", icon: "/images/framework1.png", name: "MEAN" },
    { tab: "Frameworks", icon: "/images/framework4.png", name: "Rxweb.io" },
    { tab: "Frameworks", icon: "/images/framework5.png", name: "CakePHP" },
    { tab: "Cloud", icon: "/images/cloud1.png", name: "Google Cloud" },
    { tab: "Cloud", icon: "/images/cloud2.png", name: "Azure" },
    { tab: "Cloud", icon: "/images/cloud3.png", name: "AWS" },
    { tab: "Cloud", icon: "/images/DigitalOcean.png", name: "Digital Ocean" },
    { tab: "DevOps", icon: "/images/devops1.png", name: "Gradle" },
    { tab: "DevOps", icon: "/images/devops2.png", name: "Kubernetes" },
    { tab: "DevOps", icon: "/images/devops3.png", name: "Docker" },
    { tab: "DevOps", icon: "/images/devops4.png", name: "Jenkins" },
    {
      tab: "DevOps",
      icon: "/images/openshift-svgrepo-com.svg",
      name: "Open Shift",
    },
    { tab: "DevOps", icon: "/images/packer-svgrepo-com.svg", name: "Packer" },
    { tab: "DevOps", icon: "/images/ansible-svgrepo-com.svg", name: "Ansible" },
    {
      tab: "DevOps",
      icon: "/images/saltstack-svgrepo-com.svg",
      name: "Salt Stack",
    },
    { tab: "Ecommerce", icon: "/images/ecomres1.png", name: "NopCommerce" },
    { tab: "Ecommerce", icon: "/images/ecomres2.png", name: "Kentico" },
    { tab: "Ecommerce", icon: "/images/ecomres3.png", name: "Shopify" },
    { tab: "Ecommerce", icon: "/images/ecomres4.png", name: "Magento" },
    { tab: "Ecommerce", icon: "/images/ecomres5.png", name: "WooCommerce" },
    { tab: "Platforms", icon: "/images/platform1.png", name: "Servicenow " },
    { tab: "Platforms", icon: "/images/platform2.png", name: "Tableau" },
    {
      tab: "Platforms",
      icon: "/images/platform3.png",
      name: "MS Dynamics CRM",
    },
    { tab: "Platforms", icon: "/images/platform4.png", name: "Zoho" },
    { tab: "Platforms", icon: "/images/platform5.png", name: "Power BI" },
    { tab: "Platforms", icon: "/images/platform6.png", name: "Salesforce " },
  ];
  const slidesData = [
    {
      heading: "We are the experts",
      text: "Our team members are highly skilled in a wide range of technologies & industries. We stay ahead of the curve & guarantee that we offer the most creative & practical solutions for your needs thanks to our ongoing education & certifications.",
    },
    {
      heading: "Nearshore timezones",
      text: "Our team works in your nearshore time zones, offering seamless collaboration with minimal time zone differences. This ensure that your project proceeds easily & effectively by facilitating real-time communication & quick response times.",
    },
    {
      heading: "Nothing beats our quality",
      text: "We prioritize delivering top-notch quality in every project. Our comprehensive quality assurance procedures, which include comprehensive testing & code reviews, guarantee that your software is dependable, secure, & operates at its best.",
    },
    {
      heading: "Flexibility & adaptiveness",
      text: "We understand that project requirements can change. Our flexible & adaptive approach allows us to respond swiftly to evolving needs, ensuring your project remains on track & aligned with your goals.",
    },
    {
      heading: "We take security seriously",
      text: "To give you peace of mind, our team implements rigorous security measures at all stages of development to protect your data & ensure compliance with industry standards.",
    },
    {
      heading: "We deliver value",
      text: "Our value-based mindset drives us to deliver more than just a service. We are committed to understanding your business objectives & providing solutions that offer real, measurable value, helping you achieve long-term success.",
    },
  ];

  const HireUsData = [
    {
      id: 1,
      icon: "/images/icon1.svg",
      heading: "AI Development",
      text: "We help you leverage advanced AI technologies like LLMs, chatbots, & NLP to automate processes & gain insightful, data-driven decisions tailored to your business needs.",
      btnLink: "contact-us",
    },
    {
      id: 5,
      icon: "/images/dashboard.png",
      heading: "Blockchain Development",
      text: "Leverage secure & transparent blockchain solutions to enhance your business operations, boost security, & foster trust.",
      btnLink: "contact-us",
    },
    // {
    //   id: 12,
    //   icon: "/images/high-values-icons/robust-architecture.svg",
    //   heading: "Cyber Security",
    //   text: "Protecting your digital assets with comprehensive security solutions against evolving threats.",
    //   btnLink: "contact-us",
    // },
    {
      id: 3,
      icon: "/images/machine-learning.png",
      heading: "Custom Software Development",
      text: "Need tailored solutions? Our custom software development transforms your vision into reality, optimizing efficiency & innovation.",
      btnLink: "contact-us",
    },
    // {
    //   id: 4,
    //   icon: "/images/icon3.svg",
    //   heading: "Data Analytics",
    //   text: "Unlock the power of data with AI-driven analytics, BI insights, & predictive models to fuel data-driven decision-making.",
    //   btnLink: "contact-us",
    // },
    {
      id: 7,
      icon: "/images/cloud.png",
      heading: "Cloud Solutions",
      text: "Supercharge your cloud infrastructure with expert DevOps services on AWS, GCP, & Azure—ensuring scalability, security, & peak efficiency.",
      btnLink: "contact-us",
    },
    {
      id: 8,
      icon: "/images/web-programming.png",
      heading: "Cyber Security",
      text: "Empower your digital presence with scalable, high-performance web apps designed for seamless user engagement & business growth",
      btnLink: "contact-us",
    },
    {
      id: 9,
      icon: "/images/mobile-development.png",
      heading: "Software Development",
      text: "Transform ideas into powerful, high-speed mobile apps with cutting-edge native, hybrid, & cross-platform solutions for iOS & android.",
      btnLink: "contact-us",
    },
    {
      id: 6,
      icon: "/images/dekstop-icon.svg",
      heading: "Desktop App Development",
      text: "Enhance productivity with custom-built, secure, & high-performance desktop apps tailored to your unique business needs.",
      btnLink: "contact-us",
    },
    {
      id: 10,
      icon: "/images/software-testing.png",
      heading: "QA & Software Testing",
      text: "Ensure flawless software with comprehensive QA services, manual testing, & automated solutions for seamless performance.",
      btnLink: "contact-us",
    },
    {
      id: 11,
      icon: "/images/video-marketing.png",
      heading: "Digital Branding & Growth",
      text: "Amplify your brand’s online presence with data-driven digital branding strategies to boost engagement & build lasting customer connections.",
      btnLink: "contact-us",
    },
  ];

  const scrollerData = [
    {
      text: "Hire Us",
      link: "hire-us",
    },
    {
      text: "Why Us",
      link: "why-us",
    },
    {
      text: "Our Stacks ",
      link: "our-stacks",
    },
    {
      text: "IT Services",
      link: "it-services",
    },
    {
      text: "Models",
      link: "engagment-modesl",
    },
    {
      text: "Industries ",
      link: "pioner-change-box",
    },
    {
      text: "Recognition",
      link: "globally-recognized",
    },
    // {
    //   text: "Case Study",
    //   link: "case-study",
    // },
    {
      text: "Insights",
      link: "trends",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          AI, Blockchain & Technology Services | Bitsclan IT Solutions
        </title>
        <meta
          name="description"
          content="Unlock innovation with Bitsclan. Expert software development, AI services, mobile app solutions, & blockchain technology tailored to your needs. Contact us now"
        />
      </Helmet>

      <MegaMenu />

      <SlidOnScrollBanner sectionsData={AustraliaSectionsData} />

      <TrustedPartner />

      {/* <PageScroller content={AusScrollerData} /> */}

      {/* <HomeLogo /> */}

      <OurServices buttonText="Contact Us"
        servicesCardsData={ksaHomehireServicesInsights?.topBox}
        shortHeading={ksaHomehireServicesInsights?.shortHeading}
        mainHeading={ksaHomehireServicesInsights?.heading}
        description={ksaHomehireServicesInsights?.description} />

      <CoverTheStack
        whereStart={"Frontend"}
        tabs={tabs}
        tabItems={tabItems}
        mainHeading={
          "Don't worry! We've got the tech stack you're looking for!"
        }
        // subHeading={
        //   "We have experts for every tech stack. "
        // }
        secondSubHeading={
          "We have experts in almost all major & common tech stacks. Our team is rapidly expanding, covering more programming languages & expertise. You can be confident you'll get the experts you need when you work with us."
        }
      />

      {/* <WhyUs
        slidesData={slidesData}
        heading="for Software Development & Consulting Services?"
        greenHeading="Why Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
        // secondContent="We take ownership of the project & deliver it to the finish line."
      /> */}

      <NewCaseStudySection
        shortHeading="Our Case Studies"
        heading="Trusted by the World's Leading Companies"
        description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries."
      />

      <WhyChooseUs
        heading="for Software Development & Consulting Services?"
        greenHeading="Why Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
      />



      <HireForUs
        HireUsData={HireUsData}
        heading="Hire us for Full-Spectrum Tech Services That Drive Results"
        content={[
          "Whether you need custom software, strategic IT consulting, cutting-edge blockchain, advanced AI, or solid cybersecurity right here in the United States, we’ve got you covered.",
        ]}
      // content="From advanced software development & IT consulting to blockchain, QA automation, & cybersecurity—we provide solutions that drive innovation."
      />

      {/* <EngagmentModels /> */}
      {/* <NewEngagementModels /> */}
      <SimpleModels content={engagementModelsContent} />

      <IndustriesSection />
      {/* 
      <PioneeringChange
        tabData={translatedTabData}
        greenHeading={"Across Industries"}
        mainHeading={"Pioneering Change"}
        content={
          "Our AI & IT services & solutions create long lasting competitive advantages & support diverse use cases across all major industries."
        }
      /> */}

      {/* <OurTeams /> */}

      {/* <BrandImages /> */}

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights category="all" />

      {/* <OurLocations /> */}

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
}

export default AustraliaHome;
